import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Eye, Gift, ShoppingBag } from 'lucide-react';
import BottomNavigation from '../components/BottomNavigation';

const WishlistHubPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-contribo-navy via-contribo-navy to-gray-900 pb-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-contribo-navy to-contribo-gold p-4 shadow-xl">
        <div className="flex items-center gap-2">
          <Gift className="text-white" size={24} />
          <h1 className="text-xl font-bold text-white">Wishlist</h1>
        </div>
        <p className="text-gray-200 text-xs mt-1">Create & share your wishlists</p>
      </div>

      {/* Main Content */}
      <div className="p-4 space-y-4">
        {/* Create Wishlist Tile */}
        <button
          onClick={() => navigate('/wishlist/my-wishlists')}
          className="w-full bg-white rounded-xl shadow-lg p-5 flex items-center gap-4 hover:shadow-xl transition-all active:scale-[0.98]"
        >
          <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-700 rounded-xl flex items-center justify-center flex-shrink-0">
            <Plus className="text-white" size={28} />
          </div>
          <div className="flex-1 text-left">
            <h2 className="text-lg font-bold text-gray-800">Create / Share Wishlist</h2>
            <p className="text-xs text-gray-500 mt-0.5">Create up to 3 wishlists & share with friends</p>
          </div>
          <ShoppingBag className="text-gray-400" size={20} />
        </button>

        {/* View Others' Wishlist Tile */}
        <button
          onClick={() => navigate('/wishlist/view-others')}
          className="w-full bg-white rounded-xl shadow-lg p-5 flex items-center gap-4 hover:shadow-xl transition-all active:scale-[0.98]"
        >
          <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center flex-shrink-0">
            <Eye className="text-white" size={28} />
          </div>
          <div className="flex-1 text-left">
            <h2 className="text-lg font-bold text-gray-800">View Wishlist</h2>
            <p className="text-xs text-gray-500 mt-0.5">Access &amp; contribute to friends&apos; wishlists</p>
          </div>
          <Gift className="text-gray-400" size={20} />
        </button>

        {/* Info Card */}
        <div className="bg-gradient-to-r from-contribo-gold/10 to-purple-500/10 rounded-xl p-4 border border-contribo-gold/30">
          <h3 className="text-sm font-semibold text-contribo-gold mb-2">How it works</h3>
          <ul className="text-xs text-gray-300 space-y-1.5">
            <li className="flex items-start gap-2">
              <span className="text-contribo-gold">•</span>
              Create up to 3 personal wishlists
            </li>
            <li className="flex items-start gap-2">
              <span className="text-contribo-gold">•</span>
              Share via code or link with friends
            </li>
            <li className="flex items-start gap-2">
              <span className="text-contribo-gold">•</span>
              Friends can view & contribute once approved
            </li>
            <li className="flex items-start gap-2">
              <span className="text-contribo-gold">•</span>
              Access valid for 96 hours after approval
            </li>
            <li className="flex items-start gap-2">
              <span className="text-contribo-gold">•</span>
              Wishlists expire after 30 days (extend with ₹49/year)
            </li>
          </ul>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default WishlistHubPage;
